import StatusEyebrow from "../components/StatusEyebrow";
import { ClockIcon } from "../icons";

/*
 * Processing state — the zip is still being assembled. The query polls in the
 * background (see useGetDownloadBatch) and swaps to the ready view automatically
 * the moment status flips, honoring the card's "we'll refresh this page" promise.
 */
const ProcessingView = ({ data }) => (
  <div className="card card-enter">
    <div className="card-pad">
      <StatusEyebrow dot="busy" text="Packaging" />
      <h1>We&rsquo;re zipping your photos</h1>
      <p className="sub">
        Your gallery from <b>{data.channel_name}</b> is being packaged into
        downloads. This usually takes a couple of minutes &mdash; you can keep
        this page open.
      </p>
      <div className="progress-wrap" role="status" aria-live="polite">
        <div className="progress" aria-hidden="true">
          <i />
        </div>
        <div className="progress-meta">
          <span className="dots-anim">Bundling {data.photo_count} photos</span>
          <span>Almost there</span>
        </div>
      </div>
      <div className="card-note">
        <ClockIcon size={16} />
        <span>
          We&rsquo;ll refresh this page automatically the moment it&rsquo;s ready
          &mdash; and email you too, so you don&rsquo;t have to wait here.
        </span>
      </div>
    </div>
  </div>
);

export default ProcessingView;
